export default "__VITE_ASSET__BE0mTWDg__"